import { GeneralStoreService } from './../../store/general.store';
import { AuthService } from './../../services/auth.service';
import { Component } from '@angular/core';
import { FormGroup, Validators, FormControl } from '@angular/forms';
import { HelperService } from '../../services/helper.service';
import { NotificationService } from '@optsolservices/ngx-notification';
import { ActivatedRoute, Router } from '@angular/router';
import { Token } from '../../models/token';
import { InvalidUsernamePassword, UserNotFound } from '../../models/errors';
import { User } from '../../models/user';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent {
  user: string;
  validUntil: Date;
  requestKey: string;
  userEmail: string;

  public form: FormGroup = new FormGroup({
    requestKey: new FormControl('', [Validators.required]),
    userEmail: new FormControl('', [Validators.required]),
    newPassword: new FormControl('', [Validators.required, Validators.minLength(6)]),
    verifyPassword: new FormControl(''),
  });

  constructor(
    private notificationService: NotificationService,
    private helperService: HelperService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private authService: AuthService,
    private generalStoreService: GeneralStoreService
  ) {
    this.activatedRoute.queryParams.subscribe(params => {
      this.requestKey = params.requestKey;
      this.userEmail = params.userEmail;
      this.form.setValidators(this.helperService.checkPasswordMatch('newPassword', 'verifyPassword'));
      this.form.controls.requestKey.setValue(this.requestKey);
      this.form.controls.userEmail.setValue(this.userEmail);
    });
  }

  async updatePassword(): Promise<void> {
    const response = await this.authService.userPasswordSetByRequestKey(this.form.value.userEmail, this.form.value.requestKey, this.form.value.newPassword).toPromise();
    if (response.responseCode === 0) {
      this.notificationService.success('Password has been updated successfully');
      await this.attempt();
    } else {
      this.notificationService.error(response.responseMessage);
    }

  }

  async attempt(): Promise<void> {
    try {
      const response: Token = await this.authService.attempt(this.userEmail, this.form.value.newPassword).toPromise();
      if (!response.access_token) { throw new InvalidUsernamePassword(); }

      this.generalStoreService.setToken(response.access_token);

      // TODO Implement:
      const user: User = (await this.authService.logon().toPromise()).data;
      if (!user) { throw new UserNotFound(); }

      return this.redirect(user);
    } catch (error) {
      this.notificationService.error(`Login failed: ${error?.error?.error_description}`);
    }
  }

  async redirect(user: User): Promise<void> {
    user.mustChangePassword = false;
    this.generalStoreService.setUser(user);
    this.generalStoreService.setOwners(user.owners || []);

    try {
      await this.helperService.getMenu();
    } catch (error) {
      this.generalStoreService.logout();
      this.router.navigate(['/']);
      this.notificationService.error('You are not linked to any roles, please contact your system administrator.');
      return;
    }

    let userLandingPageUrl = await this.helperService.getUserLandingPageUrl();
    userLandingPageUrl = userLandingPageUrl || '/';
    this.router.navigate([userLandingPageUrl]);
  }
}
